
import { Component, Prop, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import KeysTable from "@/components/users/KeysTable.vue";

@Component({
  components: { KeysTable},
})
export default class UserKeysTab extends Vue {

  @Prop({ default: null })
  public userId: number;

  @Getter private currentUser: any;

  private keys: object[] = [];
  private loading: boolean = false;
  private count: number = 0;

  private async getKeys(pagination: any): Promise<void> {
    this.loading = true;
    await this.$store.dispatch("users/getMyKeys", {
      id: this.userId,
      query: {
        role: "MANAGER",
        statuses: pagination.statuses,
        archived: false,
        page: pagination.page,
        itemsPerPage: pagination.itemsPerPage,
      },
    }).then((res) => {
      this.keys = res.keys;
      this.count = res.count;
    }).finally(() => {
      this.loading = false;
      this.$emit("loaded");
    });
  }
}
